<template>
    <div id="catalog">
        <headers :title='titles'></headers>
        <!-- <loadingS v-if='loading'></loadingS> -->
        <noResouse v-if='noResouse'></noResouse>
        <div class="content"
             v-if='!loading'>
            <div class="list-wrap">
                <dl class="list"
                    v-for="item,index in dataList">
                    <dt>{{item.sync_name}}</dt>
                    <template v-if="item.sync_list.length">
                        <dd v-for="d,inx in item.sync_list">
                            <span class="recom">
                                <span class="title"
                                      v-if="d.name=='单元复习'">单元复习</span>
                                <span class="title"
                                      v-else>推荐作业{{text_num[inx]}}</span>
                                <span>({{d.q_num}}题)</span>
                            </span>
                            <span class="preview"
                                  @click='preview(inx,d,d.name)'
                                  v-if="d.q_num>0">预览</span>
                            <!-- <span class="already" v-if='true'>已发过</span> -->
                            <i @click="selected(d,index,inx)"
                               :class="{'icon-fangxingkuang':!d.active,'icon-fangxing':d.active}"
                               v-if="d.q_num>0">
                                <span v-if='d.active'>移除</span>
                                <span v-else>加入</span>
                            </i>
                        </dd>
                    </template>
                    <dd v-else>暂无推荐试卷</dd>
                </dl>
                <div class="self">
                    <span>以上没有合适的? 自己选题</span>
                    <span @click='self'>自选</span>
                    <i @click='self'></i>
                </div>
            </div>
        </div>
        <div class="foot"
             v-if='!loading'>
            <div class="bottom_btn">
                <a :class="[num > 0 ?'bth_a1':'bth_a2']">
                    <span @click='allpreview'
                          v-if='num'>已选{{num}}题，点击预览</span>
                    <span v-else='num'>已选{{0}}题，点击预览</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue'

export default {
    data () {
        return {
            sid: this.$route.params.sid,
            // sid:91,
            // type: this.$route.params.type,  //2同步习题 3单元复习
            // type:2,
            closeFlag: true,
            dataList: [],
            titles: '',
            qid: [],  //所选的列表的id
            loading: true,  //加载图
            noResouse: false,  //没有资源
            num: 0,
            text_num: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十']
        }
    },
    created () {
        if (!this.$store.state.english.taskCatalog.length) {
            this.$router.go(-1);
        }
        this.titles = '同步习题';
        let cid = this.$store.state.english.taskCatalog.join(',') //需要列表也得章节id  写死了
        this.$http.post(API_URL_TASK_API + '/english/send/catalog/sync', {
            catalog_ids: cid,
            'sid': this.sid
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                if (res.data.length) {
                    this.loading = false
                    this.dataList = res.data;
                } else {
                    this.noResouse = true
                }
            } else {
                this.noResouse = true
            }
        })
    },
    components: {
        headers,
        loadingS,
        noResouse
    },

    computed: {
        cid () {
            return this.$store.state.math.chapterid.join(',')
        }
    },
    destroyed () {

    },
    methods: {
        goBack () {
            this.$router.go(-1)
        },
        close () {
            this.closeFlag = false;
        },
        send () {
        },
        preview (inx, d, name) {
            // d.title = '推荐作业一'
            // 1  全部的id
            // typeOf  全部的id  //2同步习题 3单元复习
            // //console.log(this.qid)
            let _title = '';
            if (name == '单元复习') {
                _title = '单元复习';
            } else {
                _title = '推荐作业' + this.text_num[inx];
            }
            let _qids = d.q_ids.split(',');
            this.$store.commit('setTaskQids', _qids)
            this.$router.push('/english/test/preview/0/' + this.sid + '?title=' + _title);
        },
        allpreview () {
            // 1  全部的id
            // typeOf  全部的id  //2同步习题 3单元复习
            // this.$store.commit('setscreenid',this.qid)
            // let cid = this.$store.state.english.taskCatalog.join(',')
            // this.$router.push('/english/test/taskselect')
            // //console.log(this.qid)
            let _qids = [];
            this.qid.forEach(q => {
                _qids = _qids.concat(q.qids.split(','));
            })
            // //console.log(_qids);
            this.$store.commit('setTaskQids', _qids);
            this.$router.push('/english/test/preview/1/' + this.sid);
        },
        self () {
            // this.$router.push('/sx/testPaper/taskselect/' + this.sid + '/' + this.type)
            this.$router.push('/english/test/taskselect/' + this.sid)
        },
        selected (d, index, inx) {
            if (!d.active) {
                // if(this.num>=30){
                // 	layer.tips('已经超出30道题了，无法发布')
                // }else{
                this.num += d.q_num;
                let _qids = {
                    id: d.id,
                    qids: d.q_ids
                };
                this.qid.push(_qids);
                d.active = !d.active;
                // }
            } else {
                this.qid.forEach((m, n) => {
                    if (m.id == d.id) {
                        this.num -= d.q_num
                        this.qid.splice(n, 1)
                        d.active = !d.active;
                    }
                })
            }
        }
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#catalog {
    min-height: 100vh;
    .content {
        padding-bottom: 2.8rem;
        .prompting {
            position: relative;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 24px / $ppr;
            color: #5e89ef;
            text-align: center;
            background-color: #fff;
            i {
                display: block;
                position: absolute;
                top: 36px / $ppr;
                right: 40px / $ppr;
                color: #cbcbcb;
            }
        }

        .list-wrap {
            .list {
                margin-bottom: 32px / $ppr;
                background-color: #fff;
                dt {
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    font-weight: bold;
                    color: #333;
                    @include ellipsis;
                }
                dd {
                    position: relative;
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    color: #333;
                    border-top: 1px / $ppr solid #e8e8e8;
                    i {
                        display: inline-block;
                        position: absolute;
                        top: 24px / $ppr;
                        font-size: 40px / $ppr;
                        box-sizing: border-box;
                        &.icon-fangxingkuang {
                            top: 24px / $ppr;
                            text-align: center;
                            line-height: 48px / $ppr;
                            height: 48px / $ppr;
                            width: 122px / $ppr;
                            right: 24px / $ppr;
                            border: 1px / $ppr solid #5e89ef;
                            color: #5e89ef;
                            border-radius: 50px / $ppr;
                            font-size: 28px / $ppr;
                        }
                        &.icon-fangxing {
                            top: 24px / $ppr;
                            text-align: center;
                            line-height: 48px / $ppr;
                            height: 48px / $ppr;
                            width: 122px / $ppr;
                            right: 24px / $ppr;
                            border: 1px / $ppr solid #ff6600;
                            color: #ff6600;
                            border-radius: 50px / $ppr;
                            font-size: 28px / $ppr;
                        }
                    }
                    .recom {
                        // width: 380px/$ppr;
                        min-width: 460px / $ppr;
                        margin-top: -2px / $ppr;
                        // background:#ccc;
                        // height:96px/$ppr;
                        span {
                            max-width: 260px / $ppr;
                        }
                        .title {
                            max-width: 336px / $ppr;
                            vertical-align: middle;
                            @include ellipsis;
                        }
                    }
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        // white-space: nowrap;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        &.already {
                            position: absolute;
                            right: 24%;
                        }
                        &.preview {
                            color: #5e89ef;
                            position: absolute;
                            right: 24%;
                        }
                    }
                }
            }
        }
    }
    .self {
        margin-top: 30px / $ppr;
        background-color: #fff;
        line-height: 100px / $ppr;
        padding-left: 24px / $ppr;
        position: relative;
        font-size: 30px / $ppr;
        span {
            display: inline-block;
            color: #555;
        }
        span:nth-of-type(2) {
            color: #5e89ef;
            position: absolute;
            right: 68px / $ppr;
        }
        i {
            display: inline-block;
            width: 20px / $ppr;
            height: 30px / $ppr;
            position: absolute;
            right: 24px / $ppr;
            top: 35px / $ppr;
            background: url("./img/enter.png");
            background-size: contain;
            background-repeat: no-repeat;
        }
    }
    .foot {
        position: fixed;
        bottom: 0;
        width: 100%;

        .bottom_btn {
            a {
                color: #999999;
                display: inline-block;
                height: 96px / $ppr;
                line-height: 96px / $ppr;
                width: 100%;
                text-align: center;
                font-size: $lg;
                float: left;
                box-sizing: border-box;
                &.bth_a1 {
                    background-color: #5e89ef;
                    color: #fff;
                }
                &.bth_a2 {
                    background-color: #cccccc;
                    color: #999999;
                }
                span {
                    width: 100vw;
                    display: inline-block;
                }
            }
        }
    }
}
</style>
